import { connect } from 'react-redux';
import { hasApplicationUpdate } from '~/ApplicationUpdate';
import { ApplicationState } from '~/Store';

import Layout from './Layout';

function mapStateToProps(state: ApplicationState): {
	hasPanel: boolean;
	spacedOut: boolean;
} {
	const { accessToken } = state.accessToken;

	return {
		hasPanel: accessToken !== null && accessToken.impersonatedBy !== null,
		spacedOut: hasApplicationUpdate(state.applicationUpdate),
	};
}

export default connect(mapStateToProps)(Layout);
